<template>
  <ValidationObserver v-slot="{ invalid, validate }">
    <StepTemplate
      class="StepAppointment"
      :error="error"
      stepName="stepAppointment"
      bottomBtn
      largeBtn
      @nextStep="submit(invalid, validate)"
    >
      <v-card>
        <v-tabs v-model="tab" color="secondary" grow show-arrows>
          <v-tab v-for="service in services" :key="service.key" class="text-none">
            <span>
              <v-icon left>{{ service.icon }}</v-icon>
              {{ $t(`services.${service.key}`) }}
            </span>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="service in services" :key="service.key">
            <div class="px-6 py-10">
              <div class="d-flex justify-center">
                <Services v-model="services[tab]" />
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </StepTemplate>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate'

import StepTemplate from '@/components/onboarding/UI/StepTemplate'
import Services from '@/components/settings/ServiceSettings'
import { formatHourToFloat } from '@/services/time'

export default {
  name: 'StepAppointment',

  components: { Services, StepTemplate, ValidationObserver },

  props: {
    error: String,
    schedules: {
      type: Array
    },
    services: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      tab: null
    }
  },

  methods: {
    submit(invalid, validate) {
      validate()

      const areValidIntervals = this.services.every(service =>
        this.validateIntervals(service.openings, service.duration)
      )
      if (!areValidIntervals) {
        this.$emit('error', this.$t('onBoarding.stepAppointment.errorMessage.wrongInterval'))
        return
      }

      if (!invalid) {
        this.$emit('nextStep', 4)
      }
    },
    validateIntervals(openings, duration) {
      return openings.every(({ beginHour, endHour }) => {
        if (typeof beginHour === 'string') {
          return formatHourToFloat(endHour) - formatHourToFloat(beginHour) >= duration
        } else {
          return endHour - beginHour >= duration
        }
      })
    }
  }
}
</script>
